import { QuestionCircleOutlined } from "@ant-design/icons";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message, Popconfirm, Popover, Table, Tag } from "antd";
import React, { useState } from "react";
import { FiEdit } from "react-icons/fi";
import { RiUserLocationLine } from "react-icons/ri";
import { VscTrash } from "react-icons/vsc";
import { deleteClient } from "../../../../api/apiCallManager";
import useClientInfoList from "../../../../components/hooks/useClientInfoList";
import GlobalModal from "../../../../components/modal/GlobalModal";
import useModalStore from "../../../../zustand/store/useModalStore";
import ManageClientForm from "./ManageClientForm";
import { showSuccess } from "../../../../helpers/alerts";

const ClientList = () => {
  const [clientEditData, setClientEditData] = useState("");
  const queryClient = useQueryClient();
  const { data: clientInfoList, error, isLoading } = useClientInfoList();
  const { openModal, closeModal } = useModalStore((state) => ({
    openModal: state.openModal,
    closeModal: state.closeModal,
  }));

  const handleOpenModal = (id) => {
    openModal(id); // Open modal with specific ID
  };
  const deleteClientMutation = useMutation({
    mutationFn: deleteClient,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getClientInfoListKey"] });
      showSuccess("Client deleted successfully");
    },
  });

  const handleCancel = () => {
    closeModal();
  };

  const onClientEdit = (data) => {
    setClientEditData(data);
    handleOpenModal("manageClient-Modal-Id");
  };

  const handleDelete = (id) => {
    deleteClientMutation.mutate(id);
  };

  const dataSource =
    clientInfoList?.map((client) => ({
      key: client.record_id,
      clientName: client.clientName,
      region: client.region,
      clientManager: client.clientManager,
      siteManager: client.siteManager,
    })) || [];

  const columns = [
    {
      title: "Client Name",
      dataIndex: "clientName",
      key: "clientName",
    },
    {
      title: "Region",
      dataIndex: "region",
      key: "region",
    },
    {
      title: "Client Manager",
      dataIndex: "clientManager",
      key: "clientManager",
    },
    {
      title: "Sites",
      dataIndex: "siteManager",
      key: "siteManager",
      // width: 250,
      render: (_, data) => (
        <div>
          <ul className="flex flex-wrap">
            {data?.siteManager?.map((manager, index) => (
              <li key={manager.email} className="mb-[5px]">
                <Popover content={manager.email} title="Site Manager">
                  <Tag color={"purple"}>{manager.siteName}</Tag>
                  {/* {index < data.siteManager.length - 1 && ","} */}
                </Popover>
              </li>
            ))}
          </ul>
        </div>
      ),
    },
    {
      title: "Action",
      key: "action",
      className: "text-center",
      // fixed:"right",
      render: (_, data) => (
        <div className="flex justify-center">
          <button className="mx-2" onClick={() => onClientEdit(data)}>
            <FiEdit size={15} color="#4ea927" className="opacity-[0.8]" />
          </button>
          <button>
            <Popconfirm
              title="Are you sure?"
              description="Once deleted, it cannot be recovered."
              onConfirm={() => handleDelete(data.key)}
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
            >
              <VscTrash size={18} color="red" />
            </Popconfirm>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="flex justify-end">
        {/* {JSON.stringify(clientInfoList, null, 4)} */}
        <button
          onClick={() => {
            setClientEditData("");
            handleOpenModal("manageClient-Modal-Id");
          }}
          className="crt-usr-btn mb-4"
        >
          <RiUserLocationLine className="me-1 stroke-[0.6px]" />
          Create Client
        </button>
      </div>
      <Table
        scroll={{ x: 600 }}
        className="user-table-theme"
        dataSource={dataSource}
        columns={columns}
        loading={isLoading}
      />
      <GlobalModal id="manageClient-Modal-Id" title="Manage Client">
        <ManageClientForm
          clientEditData={clientEditData}
          handleCancel={handleCancel}
        />
      </GlobalModal>
    </div>
  );
};

export default ClientList;
